// 资讯相关接口
import request from '@/utils/request'

// 资讯详情
export function basicInfoDetails(id) {
  return request({
    url: `/cultureCantonDemoApi/infoBasicInfoApi/getBasicInfoDetails?id=${id}`,
    method: 'get',
  })
}
